<template>
  <div class="breadcrumbs">
    <div class="container-fluid">
      <div class="breadcrumbs-row">
        <a href="/">
          <span>Главная </span>
        </a>
        <div class="bread-cp">-</div>
        <a href="#">
          <span>Правовая информация</span>
        </a>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <h1 class="title">Правовая информация</h1>
  </div>
  <section class="section question question-2">
    <div class="container-fluid">
      <div class="accordion acc-question" id="accordionExample">
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
                class="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#docs-cookie"
                aria-expanded="false"
                aria-controls="docs-cookie"
            >
              <div class="question-btn"></div>
              <p>Правила использования файлов cookie</p>
            </button>
          </h2>

          <div
              id="docs-cookie"
              class="accordion-collapse collapse"
              data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              <p>
                На основании Политики оператора в отношении обработки персональных данных (Редакция от 15.09.2025)
              </p>
              <h2>Общие положения</h2>
              <p>
                1.1. Настоящие Правила использования файлов cookie (далее – Правила) разработаны в соответствии с Политикой оператора в отношении обработки персональных данных (далее – Политика) и регулируют использование файлов cookie на сайте https://100levels.ru (далее – Сайт).
              </p>
              <p>
                1.2. Оператор персональных данных (далее – Оператор) – ИП Скоропупов В.В., электронная почта: info@100levels.ru.
              </p>
              <p>
                1.3. Файлы cookie – это небольшие текстовые файлы, которые сохраняются на устройстве пользователя при посещении Сайта и используются для сбора информации о действиях пользователя на Сайте.
              </p>
              <h2>
                Цели использования файлов cookie
              </h2>
              <p>
                2.1. Файлы cookie используются для достижения целей, указанных в Политике, а именно:
                <ul>
                  <li>
                    Анализ статистических метрик для улучшения работы Сайта;
                  </li>
                  <li>
                    Обеспечение удобства использования Сайта (например, запоминание предпочтений пользователя);
                  </li>
                  <li>
                    Заключение, исполнение и прекращение гражданско-правовых договоров.
                  </li>
                </ul>
              </p>
              <p>
                2.2. Обработка данных, полученных с помощью файлов cookie, ограничивается конкретными, заранее определенными и законными целями, указанными в п. 2.1 настоящих Правил.
              </p>
              <h2>
                Категории и перечень собираемых данных
              </h2>
              <p>
                3.1. С использованием файлов cookie Оператор обрабатывает следующие данные:
                <ul>
                  <li>
                    Статистические метрики (информация о посещенных страницах, времени пребывания на Сайте, типе устройства и браузера).
                  </li>
                </ul>
              </p>
              <h2>
                Использование Яндекс.Метрики
              </h2>
              <p>
                4.1. Для сбора и анализа статистических данных Оператор использует сервис Яндекс.Метрика, предоставляемый ООО «Яндекс».
              </p>
              <p>
                4.2. Яндекс.Метрика использует файлы cookie для анализа поведения пользователей на Сайте, включая данные о посещенных страницах, времени просмотра и взаимодействий на предыдущей странице, переходах по ссылкам.
              </p>
              <p>
                4.3. Данные, собранные Яндекс.Метрикой, являются обезличенными и не позволяют идентифицировать пользователя без дополнительной информации, за исключением случаев, когда пользователь предоставил персональные данные в соответствии с п. 3.2 Политики обработки персональных данных.
              </p>
              <h2>
                Порядок и условия обработки данных
              </h2>
              <p>
                5.1. Обработка данных, полученных с помощью файлов cookie, осуществляется автоматизированным способом с использованием Яндекс.Метрики.
              </p>
              <p>
                5.2. Данные хранятся в облаке в Центре обработки данных ООО "РЕГ.РУ" в соответствии с п. 5.5 Политики обработки персональных данных.
              </p>
              <p>
                5.3. Оператор обеспечивает конфиденциальность данных и не передает их третьим лицам без согласия субъекта, за исключением случаев, предусмотренных законодательством Российской Федерации.
              </p>
              <p>
                5.4. Пользователь может в любой момент отключить использование файлов cookie в настройках своего браузера, однако это может повлиять на функциональность Сайта.
              </p>
              <h2>
                Права пользователей
              </h2>
              <p>
                6.1. Пользователь имеет право:
                <ul>
                  <li>
                    Запросить информацию о наличии своих данных, собранных с помощью файлов cookie, в порядке, предусмотренном п. 6.1 Политики;
                  </li>
                  <li>
                    Требовать прекращения обработки данных, собранных с помощью файлов cookie, в порядке, предусмотренном п. 6.6 Политики;
                  </li>
                  <li>
                    Требовать исправления, удаления или уничтожения данных в случае их неточности, неактуальности или незаконной обработки в соответствии с п. 6.2–6.4 Политики.
                  </li>
                </ul>
              </p>
              <p>
                6.2. Для реализации указанных прав пользователь может направить запрос Оператору по электронной почте с указанием ФИО, контактной информации и перечня данных, обработка которых должна быть прекращена.
              </p>
              <h2>
                Меры безопасности
              </h2>
              <p>
                7.1. Оператор принимает меры для обеспечения безопасности данных, собранных с помощью файлов cookie, в соответствии с п. 5.8 Политики, включая установление правил доступа к данным.
              </p>
              <p>
                7.2. В случае выявления инцидента, связанного с неправомерной передачей данных, Оператор уведомляет уполномоченный орган в порядке, предусмотренном п. 6.5 Политики.
              </p>
              <h2>
                Срок действия и прекращение обработки данных
              </h2>
              <p>
                8.1. Обработка данных, собранных с помощью файлов cookie, прекращается в следующих случаях:
                <ul>
                  <li>
                    По требованию пользователя;
                  </li>
                  <li>
                    При достижении цели обработки;
                  </li>
                  <li>
                    При ликвидации Оператора (п. 5.6 Политики).
                  </li>
                </ul>
              </p>
              <p>
                8.2. Уничтожение данных осуществляется в сроки, указанные в п. 6.4 Политики, либо в течение 6 месяцев при отсутствии возможности немедленного уничтожения.
              </p>
              <h2>
                Контактная информация
              </h2>
              <p>
                9.1. По вопросам, связанным с использованием файлов cookie, пользователь может обратиться к Оператору по электронной почте.
              </p>
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
                class="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#docs-policy"
                aria-expanded="false"
                aria-controls="docs-policy"
            >
              <div class="question-btn"></div>
              <p>Политика обработки персональных данных (Редакция от 15.09.2025)</p>
            </button>
          </h2>
          <div
              id="docs-policy"
              class="accordion-collapse collapse"
              data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              <h2>1. Общие положения</h2>
              <p>1.1. Политика оператора в отношении обработки персональных данных (далее - Политика) разработана в целях обеспечения защиты прав и свобод субъекта персональных данных при обработке его персональных данных, в том числе защиты прав на неприкосновенность частной жизни, личную и семейную тайну.</p>
              <p>1.2. Основные понятия, используемые в Политике:</p>
              <ul>
                <li>- персональные данные - любая информация, относящаяся к прямо или косвенно определенному или определяемому физическому лицу (субъекту персональных данных);</li>
                <li>- обработка персональных данных - любое действие (операция) или совокупность действий (операций), совершаемых с использованием средств автоматизации или без использования таких средств с персональными данными, включая сбор, запись, систематизацию, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, передачу (распространение, предоставление, доступ), обезличивание, блокирование, удаление, уничтожение персональных данных;</li>
                <li>- автоматизированная обработка персональных данных - обработка персональных данных с помощью средств вычислительной техники;</li>
                <li>- распространение персональных данных - действия, направленные на раскрытие персональных данных неопределенному кругу лиц;</li>
                <li>- предоставление персональных данных - действия, направленные на раскрытие персональных данных определенному лицу или определенному кругу лиц;</li>
                <li>- блокирование персональных данных - временное прекращение обработки персональных данных (за исключением случаев, если обработка необходима для уточнения персональных данных);</li>
                <li>- уничтожение персональных данных - действия, в результате которых становится невозможным восстановить содержание персональных данных в информационной системе персональных данных и (или) в результате которых уничтожаются материальные носители персональных данных;</li>
                <li>- обезличивание персональных данных - действия, в результате которых становится невозможным без использования дополнительной информации определить принадлежность персональных данных конкретному субъекту персональных данных;</li>
                <li>- оператор персональных данных (оператор) – ИП Скоропупов В.В., электронная почта info@100levels.ru</li>
                <li>- cайт - https://100levels.ru</li>
              </ul>
              <p>1.3. Оператор, получивший доступ к персональным данным, обязан соблюдать конфиденциальность персональных данных - не раскрывать третьим лицам и не распространять персональные данные без согласия субъекта персональных данных, если иное не предусмотрено федеральным законом.</p>

              <h2>2. Цели сбора персональных данных</h2>
              <p>2.1. Обработка персональных данных ограничивается достижением конкретных, заранее определенных и законных целей. Не допускается обработка персональных данных, несовместимая с целями сбора персональных данных.</p>
              <p>2.2. К целям обработки персональных данных оператора относятся:</p>
              <ul>
                <li>- заключение, исполнение и прекращение гражданско-правовых договоров;</li>
              </ul>

              <h2>3. Правовые основания обработки персональных данных</h2>
              <p>3.1. Правовым основанием обработки персональных данных являются:</p>
              <ul>
                <li>- согласие на обработку персональных данных.</li>
              </ul>
              <p>3.2. Согласие на обработку персональных данных выражается субъектом посредством акцепта оферты, расположенной на Сайте.</p>

              <h2>4. Категории и перечень обрабатываемых персональных данных, категории субъектов персональных данных</h2>
              <p>4.1. Содержание и объем обрабатываемых персональных данных соответствуют заявленным целям обработки. Обрабатываемые персональные данные не должны быть избыточными по отношению к заявленным целям их обработки.</p>
              <p>4.2. Категория обрабатываемых персональных данных: общая.</p>
              <p>4.3. Перечень обрабатываемых персональных данных:</p>
              <ul>
                <li>ФИО;</li>
                <li>Адрес электронной почты;</li>
                <li>Статистические метрики.</li>
              </ul>
              <p>4.3. К категориям субъектов персональных данных относятся:</p>
              <p>4.3.1. Посетители Сайта.</p>
              <p>4.3.2. Клиенты.</p>

              <h2>5. Порядок и условия обработки персональных данных</h2>
              <p>5.1. Оператор осуществляет следующие действия с персональными данными: сбор, запись, систематизацию, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, обезличивание, блокирование, удаление, уничтожение персональных данных.</p>
              <p>5.2. Обработка персональных данных осуществляется автоматизированным способом с передачей по внутренней сети Оператора, с передачей по сети интернет.</p>
              <p>5.3. Оператор не осуществляет трансграничную передачу данных.</p>
              <p>5.3. Обработка персональных данных оператором ограничивается достижением конкретных, заранее определенных и законных целей. Обработке подлежат только персональные данные, которые отвечают целям их обработки. Содержание и объем обрабатываемых персональных данных должны соответствовать заявленным целям обработки.</p>
              <p>5.4. Источник получения персональных данных является Сайт.</p>
              <p>5.5. Местом хранения персональных данных является ЦОД ООО "РЕГ.РУ" по адресу Санкт-Петербург, Предпортовая улица, дом 5.</p>
              <p>5.6. Условием прекращения обработки персональных данных является ликвидация Оператора.</p>
              <p>5.7. Оператор и иные лица, получившие доступ к персональным данным, обязаны не раскрывать третьим лицам и не распространять персональные данные без согласия субъекта персональных данных.
                Передача (распространение, предоставление, доступ) персональных данных, разрешенных субъектом персональных данных для распространения, должна быть прекращена в любое время по требованию субъекта персональных данных. Данное требование должно включать в себя фамилию, имя, отчество (при наличии), контактную информацию (номер телефона, адрес электронной почты или почтовый адрес) субъекта персональных данных, а также перечень персональных данных, обработка которых подлежит прекращению. Указанные в данном требовании персональные данные могут обрабатываться только оператором, которому оно направлено.</p>
              <p>5.8. Оператор принимает следующие меры для обеспечения безопасности персональных данных: назначение оператором ответственного за организацию обработки персональных данных;
                издание оператором, являющимся юридическим лицом, документов, определяющих политику оператора в отношении обработки персональных данных;
                ознакомление работников оператора, непосредственно осуществляющих обработку персональных данных, с положениями законодательства Российской Федерации о персональных данных, в том числе требованиями к защите персональных данных, документами, определяющими политику оператора в отношении обработки персональных данных, локальными актами по вопросам обработки персональных данных, и (или) обучение указанных работников;
                установлением правил доступа к персональным данным, обрабатываемым в информационной системе персональных данных, а также обеспечением регистрации и учета всех действий, совершаемых с персональными данными в информационной системе персональных данных.</p>
              <p>5.9. Оператором обеспечена безопасность персональных данных следующим образом:</p>
              <ul>
                <li>- конфигурация установленной операционной системы, файрвол, fail2ban (программа для защиты серверов Linux)</li>
                <li>- ограничение доступа до операционной системы сервера и базы данных</li>
                <li>- шифрование паролей пользователей в базе данных</li>
                <li>- ssl-сертификат шифрования при передаче данных на сайт</li>
              </ul>

              <h2>6. Актуализация, исправление, удаление и уничтожение персональных данных, ответы на запросы субъектов на доступ к персональным данным</h2>
              <p>6.1. Оператор обязан сообщить в порядке, предусмотренном статьей 14 Закона о персональных данных, субъекту персональных данных или его представителю информацию о наличии персональных данных, относящихся к соответствующему субъекту персональных данных, а также предоставить возможность ознакомления с этими персональными данными при обращении субъекта персональных данных или его представителя, либо в течение десяти рабочих дней с даты получения запроса субъекта персональных данных или его представителя. Указанный срок может быть продлен, но не более чем на пять рабочих дней в случае направления оператором в адрес субъекта персональных данных мотивированного уведомления с указанием причин продления срока предоставления запрашиваемой информации.</p>
              <p>6.2. Оператор обязан предоставить безвозмездно субъекту персональных данных или его представителю возможность ознакомления с персональными данными, относящимися к этому субъекту персональных данных. В срок, не превышающий семи рабочих дней со дня предоставления субъектом персональных данных или его представителем сведений, подтверждающих, что персональные данные являются неполными, неточными или неактуальными, оператор обязан внести в них необходимые изменения. В срок, не превышающий семи рабочих дней со дня представления субъектом персональных данных или его представителем сведений, подтверждающих, что такие персональные данные являются незаконно полученными или не являются необходимыми для заявленной цели обработки, оператор обязан уничтожить такие персональные данные. Оператор обязан уведомить субъекта персональных данных или его представителя о внесенных изменениях и предпринятых мерах и принять разумные меры для уведомления третьих лиц, которым персональные данные этого субъекта были переданы.</p>
              <p>6.3. В случае подтверждения факта неточности персональных данных оператор на основании сведений, представленных субъектом персональных данных или его представителем, либо уполномоченным органом по защите прав субъектов персональных данных, или иных необходимых документов обязан уточнить персональные данные либо обеспечить их уточнение (если обработка персональных данных осуществляется другим лицом, действующим по поручению оператора) в течение семи рабочих дней со дня представления таких сведений и снять блокирование персональных данных.</p>
              <p>6.4. Оператор обязан прекратить обработку персональных данных или обеспечить прекращение обработки персональных данных лицом, действующим по поручению оператора:</p>
              <ul>
                <li>- в случае выявления неправомерной обработки персональных данных, осуществляемой оператором или лицом, действующим по поручению оператора, в срок, не превышающий трех рабочих дней с даты этого выявления;</li>
                <li>- в случае отзыва субъектом персональных данных согласия на обработку его персональных данных;</li>
                <li>- в случае достижения цели обработки персональных данных и уничтожить персональные данные или обеспечить их уничтожение (если обработка персональных данных осуществляется другим лицом, действующим по поручению оператора) в срок, не превышающий тридцати дней с даты достижения цели обработки персональных данных. В случае отсутствия возможности уничтожения персональных данных в течение указанного срока оператор осуществляет блокирование таких персональных данных или обеспечивает их блокирование (если обработка персональных данных осуществляется другим лицом, действующим по поручению оператора) и обеспечивает уничтожение персональных данных в срок не более чем шесть месяцев, если иной срок не установлен федеральными законами.</li>
              </ul>
              <p>6.5. В случае установления факта неправомерной или случайной передачи (предоставления, распространения, доступа) персональных данных, повлекшей нарушение прав субъектов персональных данных, оператор обязан с момента выявления такого инцидента оператором, уполномоченным органом по защите прав субъектов персональных данных или иным заинтересованным лицом уведомить уполномоченный орган по защите прав субъектов персональных данных:</p>
              <ul>
                <li>- в течение двадцати четырех часов о произошедшем инциденте, о предполагаемых причинах, повлекших нарушение прав субъектов персональных данных, и предполагаемом вреде, нанесенном правам субъектов персональных данных, о принятых мерах по устранению последствий соответствующего инцидента, а также предоставить сведения о лице, уполномоченном оператором на взаимодействие с уполномоченным органом по защите прав субъектов персональных данных, по вопросам, связанным с выявленным инцидентом;</li>
                <li>- в течение семидесяти двух часов о результатах внутреннего расследования выявленного инцидента, а также предоставить сведения о лицах, действия которых стали причиной выявленного инцидента (при наличии).</li>
              </ul>
              <p>6.6. В случае обращения субъекта персональных данных к оператору с требованием о прекращении обработки персональных данных оператор в срок, не превышающий десяти рабочих дней с даты получения им соответствующего требования, обязан прекратить их обработку или обеспечить прекращение такой обработки (если такая обработка осуществляется лицом, осуществляющим обработку персональных данных), за исключением случаев, предусмотренных Законом о персональных данных.
                Указанный срок может быть продлен, но не более чем на пять рабочих дней в случае направления оператором в адрес субъекта персональных данных мотивированного уведомления с указанием причин продления срока предоставления запрашиваемой информации.</p>
              <p>6.7. После истечения срока нормативного хранения документов, содержащих персональные данные субъекта, или при наступлении иных законных оснований документы подлежат уничтожению.</p>

            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
                class="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#docs-official"
                aria-expanded="false"
                aria-controls="docs-official"
            >
              <div class="question-btn"></div>
              <p>Оферта (редакция от 13.10.2025)</p>
            </button>
          </h2>
          <div
              id="docs-official"
              class="accordion-collapse collapse"
              data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              <p>
                <a href="/files/docs/oferta_100levels_13_10.docx" target="_blank">Оферта (Скачать)</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// @ is an alias to /src

export default {
  name: "Policy",
  data() {
    return {
      
    }
  },
  mounted() {
    const hash = window.location.hash;

    if (hash) {
      const collapseElement = document.querySelector(hash);
      const button = document.querySelector(`button[data-bs-target="${hash}"]`);

      if (collapseElement && button && collapseElement.classList.contains('accordion-collapse')) {
        button.classList.remove('collapsed');
        button.setAttribute('aria-expanded', 'true');
        collapseElement.classList.add('show');
      }
    }
    this.$nextTick(() => document.dispatchEvent(new Event("prerender-ready")));
  },

};
</script>

<style>

</style>
